import {createEvent} from "effector";

export const toggleCreateDashboardModalEv = createEvent();
export const resetCrateDashboardModalEv = createEvent()

export const setEditDashboardEv = createEvent()
export const resetEditDashboardEv = createEvent()
export const resetViewDashboardEv = createEvent()
